export const iplData = {
    'CSK': ['MS Dhoni','Ravindra Jadeja','Moeen Ali','Deepak Chahar','Mitchell Santner'],
    'MI': ['Rohit Sharma','Suryakumar Yadav','Ishan Kishan','Jasprit Bumrah','Kieron Pollard'],
    'GT': ['Hardik Pandya','David Miller','Shubman Gill','Rashid Khan','Mohammed Shami'],
    'RR': ['Jos Buttler','Sanju Samson','Devdutt Padikkal','Trent Boult','Yuzi Chahal']
}